import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from './NotEditableWidget.module.scss';

interface Props {
    title: string;
    description: string | React.ReactNode;
}

export const NotEditableWidget = ({ title, description }: Props) => {
    return (
        <div className={classes.NotEditableWidget}>
            <div className={classes.iconWrapper}>
                <MuiIcon icon={'lock'} type={'outlined'} fontSize={'6rem'} />
            </div>
            <div className={classes.title}>{title}</div>
            <div className={classes.description}>{description}</div>
        </div>
    );
};
